import React, {useState,useEffect} from "react";
import { arrayMoveImmutable } from "array-move";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from "react-sortable-hoc";
import clsx from "clsx";
import { IconDrag } from "@/components/Icon";
import styles from "./index.module.less";

const DragIndex = ({ value, onChange }) => {

  const [state,setState] = useState({
    items: []
  });

  useEffect(() => {
    console.log("-------value------",value)
    setState({
      items: value
    });
  }, [value]);

  const onSortEnd = ({oldIndex, newIndex}) => {
    if (oldIndex === newIndex) return;
    const newList = arrayMoveImmutable(value, oldIndex, newIndex);
    onChange(newList);
  };

  const handleChange = (checked, index) => {
    value = value.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          visible: checked
        };
      }
      return item;
    })
    //value = _.cloneDeepWith(value,true)
    onChange(value);
    console.log(value)
    // onChange(
    //
    // );
  };

  const DragHandle = SortableHandle(() => (
    <IconDrag size={16} color="#91919F" style={{ cursor: "move" }} />
  ));

  const SortableItem = SortableElement(({item}) => {
    const { visible, readOnly, title,dataIndex } = item;
    let disabled = Boolean(item.disabled)
    const realIndex = value.findIndex(item => item.dataIndex === dataIndex);
    return (
      <div
        className={clsx(styles.optionLine, { [styles.disabled]: readOnly })}
      >
        <DragHandle />
        <div className={styles.inputBox}>
          <FormControlLabel
            style={{ display: "flex" }}
            disabled={disabled}
            checked={visible}
            onChange={(e)=>handleChange(e.target.checked, realIndex)}
            control={<Checkbox color="primary" onClick={e => e.stopPropagation()}/>}
            label={<span dangerouslySetInnerHTML={{ __html: title }} />}
          />
        </div>
      </div>
    );

  });


  const SortableList = SortableContainer(({items}) => {
    return (
      <div className={styles.sortBox}>
        {items.filter(item => item.invisible !== true).map((item, index) => {
          return (
            <SortableItem
              index={index}
              key={`item-${index}`}
              item={item}
            />
          )
        })}
      </div>
    );
  });

  return (
    <div className={styles.optionsBox}>
      <SortableList items={state.items} onSortEnd={onSortEnd}/>
    </div>
  );
}

export default DragIndex;
